import * as React from 'react'
import {FC} from 'react'
import CalcCard from '../../../../common/components/calc-card'
import Form, {FormInstance} from 'antd/lib/form'
import Radio from 'antd/lib/radio'
import IDS from '../../constants/ids'
import {INSURANCE_PROGRAMS} from '../../constants/insurance-programs'
import {STANDARD_ITEM_RULES_SELECT} from '../../../../common/constants'
import LABELS from '../../constants/labels'
import Row from 'antd/lib/row'
import 'antd/lib/row/style'
import Col from 'antd/lib/col'
import 'antd/lib/col/style'
import './index.less'

interface InsTypePropsInterface {
    form: FormInstance
    onValueChange: (fieldName: string | string[]) => void
}

const {Item} = Form,
    {Group} = Radio

const InsType: FC<InsTypePropsInterface> = ({onValueChange, form}) => {
    // Не даёт сделать запрос цены, если сумма указана неверно
    const handleChange = (eventOrValue, id) => {
        const currentInsSum = form.getFieldValue(IDS.INSURANCE_SUM)
        if (currentInsSum && parseInt(currentInsSum) > 0) {
            onValueChange(id)
        }
    }
    return (
        <CalcCard>
            <h2>Тип страховки</h2>

            <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                <Col xs={24} sm={24} md={24}>
                    <Item name={IDS.INSURANCE_TYPE} rules={STANDARD_ITEM_RULES_SELECT} required>
                        <Group
                            className='e-full-wide'
                            onChange={e => {
                                handleChange(e, IDS.INSURANCE_TYPE)
                            }}
                        >
                            {Object.keys(INSURANCE_PROGRAMS).map((key, index) => (
                                <Radio value={key} key={key} className='e-ins-type__item'>
                                    {INSURANCE_PROGRAMS[key]}
                                </Radio>
                            ))}
                        </Group>
                    </Item>
                </Col>
            </Row>
            <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                <Col xs={24} sm={24} md={24}>
                    <Item
                        name={IDS.FRANCHISE}
                        label={LABELS.FRANCHISE}
                        rules={STANDARD_ITEM_RULES_SELECT}
                    >
                        <Group
                            className='e-full-wide'
                            onChange={e => {
                                handleChange(e, IDS.FRANCHISE)
                            }}
                        >
                            <Radio value={true} key={`franchise-yes`}>
                                С использованием безусловной франшизы
                            </Radio>
                            <Radio value={false} key={`franchise-no`}>
                                Без франшизы
                            </Radio>
                        </Group>
                    </Item>
                </Col>
            </Row>
        </CalcCard>
    )
}

export default InsType
